import {
  getLandingPageBySlug,
  getProgrammaticLandingPageBySlug,
} from '../content/landingPages'
import { parseBlogPath } from '../content/blog'
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from './index'

const GERMAN_ONLY_PUBLIC_ROUTES = new Set([
  '/pv-rechner',
  '/pv-kostenrechner',
  '/photovoltaik-ertrag-staedte-ranking',
  '/partner',
  '/impressum',
  '/datenschutzerklaerung',
])

/**
 * Resolves the UI locale owned by a public URL. Returning undefined is deliberate for routes
 * without a locale contract (the bare root before its redirect, admin and unknown routes), where
 * cached/browser/server language detection may still choose the destination language.
 */
export function resolveRouteLocale(pathname: string): SupportedLanguage | undefined {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
  if (GERMAN_ONLY_PUBLIC_ROUTES.has(normalizedPath)) return 'de'

  const blogRoute = parseBlogPath(normalizedPath)
  if (blogRoute) return blogRoute.lang

  const slug = normalizedPath.replace(/^\//, '')
  const landingPage = getLandingPageBySlug(slug) ?? getProgrammaticLandingPageBySlug(slug)
  if (landingPage) return landingPage.lang

  const firstSegment = normalizedPath.split('/')[1]
  if ((SUPPORTED_LANGUAGES as readonly string[]).includes(firstSegment)) {
    return firstSegment as SupportedLanguage
  }

  return undefined
}
